export class ResponseError extends Error {
  text: string;
  status: number;
  constructor(status: number, message: string, text: string) {
    super(message);
    this.status = status;
    this.text = text;
  }
}
